import styled from '@emotion/styled';

export const ToggleStyle = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  .react-switch-checkbox {
    height: 0;
    width: 0;
    visibility: hidden;
    position: relative;
  }

  .react-switch-label {
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    width: 38px;
    height: 22px;
    background: ${(p) => p.theme.colors.n300};
    border-radius: 50px;
    position: relative;
    transition: background-color 0.2s;
  }

  .react-switch-checkbox:checked + .react-switch-label {
    background-color: ${(p) => p.theme.colors.p500};
  }

  .react-switch-label:active {
    background-color: ${(p) => p.theme.colors.p500};
  }

  .react-switch-label .react-switch-button {
    content: '';
    position: absolute;
    top: 3px;
    left: 2px;
    width: 16px;
    height: 16px;
    border-radius: 45px;
    transition: 0.2s;
    background: ${(p) => p.theme.colors.n100};
    box-shadow: 0 0 2px 0 rgba(10, 10, 10, 0.29);
  }

  .react-switch-checkbox:checked + .react-switch-label .react-switch-button {
    left: calc(100% - 2px);
    transform: translateX(-100%);
  }
`;
